import React, { useState, useRef, useEffect } from 'react';
import s from './style.module.scss';
import cx from 'classnames';

function isFunction(func) {
  return typeof func === 'function';
}

const VerificationInput = (props) => {
  const { count = 6, className, placeHolder, extraContent, onComplete, onChange, initialValue } = props;
  const [inputs, setInputs] = useState(new Array(count).fill(''));
  const inputRefs = useRef(inputs.map(() => React.createRef()));
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!initialValue) return;
    initialValue.join('').length >= count && setInputs([...initialValue]);
  }, [initialValue, count]);

  // 使用useEffect来监听inputs的变化，并在输入后移动焦点
  useEffect(() => {
    const inputValues = [];
    inputs.forEach((input, index) => {
      if (input && index === activeIndex && index < inputs.length - 1) {
        inputRefs.current[index + 1].current.focus();
      }
      if (!input && index === activeIndex && index < inputs.length - 1) {
        inputRefs.current[index].current.focus();
      }
      if (input) {
        inputValues.push(input);
      }
    });
    if (inputValues?.join('').length === count) {
      isFunction(onComplete) && onComplete(inputs);
    }
  }, [inputs]);

  const handleChange = (value, index) => {
    setActiveIndex(index);
    const newInputs = [...inputs];
    if (!value || /\d/.test(value)) {
      newInputs[index] = value;
      setInputs(newInputs);
    }
    isFunction(onChange) && onChange(newInputs);
  };

  const handleFocus = (index) => {
    // 如果点击的输入框已经有值，不自动跳转到第一个空输入框
    setActiveIndex(index);
    if (inputs[index]) return;
    const firstEmptyIndex = inputs.findIndex((input) => input === '');
    if (firstEmptyIndex !== -1 && firstEmptyIndex < index) {
      inputRefs.current[firstEmptyIndex].current.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    setActiveIndex(index);
    if (e.key === 'Backspace') {
      const newInputs = [...inputs];
      if (inputs[index] || index === 0) {
        // 如果当前输入框有值，或者是第一个输入框，则清除当前输入框的值
        newInputs[index] = '';
        setInputs(newInputs);
        // 特别处理第一个输入框，防止焦点丢失
        if (index === 0) {
          inputRefs.current[index].current.focus();
        }
      }
      if (!inputs[index] && index > 0) {
        // 如果当前输入框为空，并且不是第一个输入框，则删除前一个输入框的值，并将焦点移动到前一个输入框
        newInputs[index - 1] = '';
        setInputs(newInputs);
        inputRefs.current[index - 1].current.focus();
      }
      isFunction(onChange) && onChange(newInputs);
    }
  };

  return (
    <div className={s.wrapper}>
      {inputs.map((input, index) => (
        <>
          <input
            className={cx(s.input, className)}
            key={index}
            ref={inputRefs.current[index]}
            value={input}
            onChange={(e) => handleChange(e.target.value, index)}
            onFocus={() => handleFocus(index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            maxLength={1}
            type="tel"
            placeholder={placeHolder?.[index]}
          />
          {extraContent?.[index]}
        </>
      ))}
    </div>
  );
};

export default VerificationInput;
